import { Injectable } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { constant } from '../../app.constants';

@Injectable()
export class ZipCodeFloridaService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
  }

  /**
   * @name getZipCodeFlorida
   */
  getZipCodeFlorida() {
    return this._http
      .get(
        `${constant.URL_ZIPCODES_FLORIDA}`,
        this.getHeader())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getFacilityById
   * @description
   * @param id
   */
  getZipCodeFloridaById(id: number) {
    return this._http
      .get(constant.URL_GET_ZIPCODES_FLORIDA_BY_ID + '/' + id, this.getHeader())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name postData
   * @description
   * @param data
   */
  postData(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http
      .post(constant.URL_ZIPCODES_FLORIDA, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putData
   * @description
   * @param data
   */
  putData(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http
      .put(constant.URL_ZIPCODES_FLORIDA, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name deleteData
   * @description
   * @param data
   */
  deleteData(data: any) {
    return this._http
      .delete(`${constant.URL_FACILITY}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  deleteZipCode(zipCode: string) {
    return this._http
      .delete(`${constant.URL_ZIPCODES_FLORIDA}/${zipCode}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/zip-code-florida/zip-code-florida.service.ts